import TanStackQueryProvider from '@/common/components/providers/TanStackQueryProvider.tsx';
import MainRoute from '@/config/MainRoute.tsx';
import ToastProvider from '@/common/components/providers/ToastProvider.tsx';

function App() {
  
  return (
    <TanStackQueryProvider>
      <MainRoute />
      <ToastProvider />
    </TanStackQueryProvider>
  );
}

export default App;
